import { uploadAsset } from '../api/aws/aws';
import { toast } from 'react-hot-toast';
import { UseFormSetValue } from 'react-hook-form';

export const uploadBankStatement = async <T extends Record<string, any>>(
  files: File[],
  setValue: UseFormSetValue<T>,
  setFiles: (files: File[]) => void,
  setIsUploading: (isUploading: boolean) => void
): Promise<void> => {
  if (files.length === 0) return;

  setIsUploading(true);
  try {
    const file = files[0];
    const fileKey = await uploadAsset(
      file,
      'APPLICANTS',
      'bank-statements'
    );
    setValue('bankDetails.bankStatement' as any, fileKey);
    setFiles([file]);
    toast.success('Bank statement uploaded successfully!');
  } catch (error) {
    console.error('Upload error:', error);
    toast.error('Failed to upload bank statement');
  } finally {
    setIsUploading(false);
  }
};